import RouteView from "../../../../Routes/RouteView";
import ExpensesNavOptions, { defaultRoute } from "./ExpensesNavOptions";
const Expenses = () => {
	return (
		<RouteView defaultRoute={defaultRoute}>{ExpensesNavOptions}</RouteView>
	);
};

export default Expenses;
